var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.825 4.93714C15.7348 -1.64692 6.26276 -1.64451 0.17494 4.93714C-0.053998 5.18464 -0.0584668 5.60371 0.162908 5.86045L1.33991 7.22531C1.55097 7.4704 1.8906 7.47563 2.10991 7.24058C7.12591 1.86951 14.8734 1.8683 19.8904 7.24058C20.1097 7.47563 20.4493 7.47 20.6604 7.22531L21.8374 5.86045C22.0584 5.60371 22.054 5.18464 21.825 4.93714ZM11 12.8571C9.78482 12.8571 8.79998 14.0083 8.79998 15.4286C8.79998 16.8489 9.78482 18 11 18C12.2151 18 13.2 16.8489 13.2 15.4286C13.2 14.0083 12.2151 12.8571 11 12.8571ZM17.9668 9.49862C14.0047 5.40321 7.99079 5.40763 4.03319 9.49862C3.796 9.74371 3.78844 10.1692 4.0136 10.4288L5.19747 11.7944C5.40372 12.0323 5.73579 12.0483 5.95544 11.8266C8.84123 8.9108 13.1653 8.91723 16.0442 11.8266C16.2638 12.0483 16.5959 12.0327 16.8021 11.7944L17.986 10.4288C18.2115 10.1692 18.2036 9.7433 17.9668 9.49862Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.108abcdc76777dee2ae5e0f3ed6bbbe2.svg";
export { ForwardRef as ReactComponent };